import { SearchServicesOptions } from './search-service'

export const searchServiceKeys = {
  all: ['search-service'] as const,
  lists: () => [...searchServiceKeys.all, 'list'] as const,
  list: (query?: string) => [...searchServiceKeys.lists(), query] as const,
  details: () => [...searchServiceKeys.all, 'detail'] as const,
  detail: (oid: string) => [...searchServiceKeys.details(), oid] as const,
  finder: (query: string | undefined) => [...searchServiceKeys.all, 'finder', query] as const,
  search: (options: SearchServicesOptions) => [...searchServiceKeys.all, 'search', { ...options }] as const,
}
